/**
 * API Configuration
 *
 * Set VITE_API_MODE in .env to switch between:
 * - "local"  - local dev server           (dev only; default in dev)
 * - "remote" - deployed AWS API           (always used in production builds)
 *
 * Production builds always resolve to "remote": local is dev-only and a
 * production build can never silently point at a dev backend even if
 * VITE_API_MODE is unset or wrong. See resolveApiMode for the rules.
 */
import { resolveApiMode } from './resolveApiMode';

export const API_MODE = resolveApiMode(import.meta.env.VITE_API_MODE, import.meta.env.DEV);

const API_CONFIG = {
  local: {
    baseUrl: 'http://localhost:3001',
  },
  remote: {
    baseUrl: import.meta.env.VITE_API_URL || '',
  },
};

export const getBaseUrl = () => (API_CONFIG[API_MODE] || API_CONFIG.remote).baseUrl;
